export default ['Welcome', 'Health Screen', 'Take sample', 'Confirmation']
